<template>
  <div v-if="show" class="mobile_search_wrapper"> 
		<div class="ms_topbar">
			<div class="mst_input_wrap">
                <div class="mst_icon" @click="search(sugg)">
					<img src="/img/green_search.svg">
				</div>
				<input class="mst_input" 
                                        type="text"
                        name="search"
                       enterkeyhint="search"
                    id="mobile_search_input"
                    v-focus
                    v-model.trim="searchInput"
                >
                <img 
                    v-if="!searchComponent.isIE" 
                    class="keyboard_icon mr_5" 
                    @click="searchComponent.displayKeyboard()" 
                    src="/img/np_keyboard.svg" 
                >
			</div>
			<div @click="close()" class="mst_ex">
				<img src="/img/atc_ex_white.svg">
			</div>
		</div>
		<div class="mst_bottom">
            <p class="mst_suggest"
            v-for="(sugg, index) in searchComponent.searchSuggestions"
            :key="index"
            v-html="sugg"
            @click="search(sugg)"></p>
		</div>

        <custom-keyboard 
            v-if="searchComponent.showKeyboard" 
            :input="searchInput"
            @onChangeInput="input => searchInput = input"
            @enterClicked="search(searchInput)"
            id="keyboard"
	    >
            <p class="gpb_head_ex ex-keyboard">
				<img id="ex" @click="searchComponent.displayKeyboard()" class="img_contain" src="/img/ex_grey.svg">
			</p>
        </custom-keyboard>

	</div>
</template>

<script>
import { removeDisturbingElm, addDisturbingElm } from '../../mixins/manageDisturbingElm'
export default {
    data() {
        return {
            searchComponent: {},
            show: false,
            searchInput: '',
            searchSuggestions: [],
        }
    },
    methods: {
        open() {
            this.searchComponent = this.$parent.$parent.$refs.search
            this.searchInput = this.searchComponent.searchInput
            this.show = true
        },
        close() {
            this.show = false;
        },
        search(sugg) {
            this.searchComponent.search(sugg)
            this.show = false
            this.searchInput = sugg
        },
        controlEvents($event) {
            if (event.target.id == 'mobile_search_input' && event.keyCode == 13) {
                this.search(event.target.value)
            }

        }
    },
    mounted() {
        document.addEventListener("keydown", this.controlEvents)
    },
    watch: {
        searchInput(val) {
            if (!this.show) return
            this.searchComponent.searchInput = this.searchInput
            this.searchComponent.initiateSearchRequest()
        },

        show() {
            this.show ? removeDisturbingElm(this.$root) : setTimeout(() => addDisturbingElm(this.$root), 5000)
        }
    }
}
</script>

<style>
.mobile_search_wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100000;
    bottom: 0;
}

.mst_bottom {
    overflow: scroll;
}

.mst_suggest {
    cursor: pointer;
}

.ex-keyboard {
    position: absolute;
    right: 0;
    top: -30px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/layouts/MobileSearch.vue